export const DOCUMENT_TYPE_OPTIONS = [
  { value: 'RC', label: 'Registro Civil' },
  { value: 'TI', label: 'Tarjeta de Identidad' },
  { value: 'CC', label: 'Cédula de Ciudadanía' },
  { value: 'PA', label: 'Pasaporte' },
  { value: 'DE', label: 'Documento Extranjero' },
  { value: 'PE', label: 'Permiso Especial de Permanencia' },
  { value: 'CE', label: 'Cédula de Extranjería' },
];

export const SEX_OPTIONS = [
  { value: 'M', label: 'Mujer' },
  { value: 'H', label: 'Hombre' },
  { value: 'I', label: 'Intersexual' },
  { value: 'X', label: 'Indefinido' },
];

export const OCCUPATION_OPTIONS = [
  { value: 'estudiante', label: 'Estudiante' },
  { value: 'empleado', label: 'Empleado' },
  { value: 'independiente', label: 'Trabajador independiente' },
  { value: 'desempleado', label: 'Desempleado' },
  { value: 'hogar', label: 'Oficios del hogar' },
  { value: 'pensionado', label: 'Pensionado' },
  { value: 'otro', label: 'Otro' },
];

export const HOW_DID_YOU_HEAR_OPTIONS = [
  { value: 'facebook', label: 'Redes sociales - Facebook' },
  { value: 'x-twitter', label: 'Redes sociales - X' },
  { value: 'instagram', label: 'Redes sociales - Instagram' },
  { value: 'linkedin', label: 'Redes sociales - LinkedIn' },
  { value: 'tiktok', label: 'Redes sociales - TikTok' },
  { value: 'medios-digitales', label: 'Medios de comunicación digitales' },
  { value: 'medios-tradicionales', label: 'Medios tradicionales (radio, TV, prensa)' },
  { value: 'recomendacion', label: 'Recomendación de un conocido' },
  { value: 'stand-informativo', label: 'Stand informativo' },
  { value: 'otro', label: 'Otro' },
];

export const EVENT_ACTIVITY_OPTIONS = [
  { value: 'campus-virtual', label: 'Campus Virtual' },
  { value: 'curso-presencial', label: 'Curso Presencial' },
  { value: 'taller', label: 'Taller' },
  { value: 'webinar', label: 'Webinar' },
  { value: 'evento-networking', label: 'Evento de Networking' },
  { value: 'capacitacion', label: 'Capacitación' },
  { value: 'otro', label: 'Otro' },
];
